import { API_URL } from "../config";
export const LANDSCAPE_DEFAULT_URL = `${API_URL}/patents/v6/_search`;
export const LANDSCAPE_DEFAULTS = {
  hevc: {
    version: "v5",
    versionsPublic: ["v5"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/360007517393-Video-Codec-Zone-Methodology",
    fields: {
      v5: "hevc_v6a_ft_c",
      trsent: "hevc_v5a_trsent_claim",
      trsentUS: "hevc_v5a_trsent_us_claim"
    },
    venn: {
      v5: {
        pools: ["Access Advance Hevc Members", "Via-La Hevc Members", "Avanci Video Members"]
      },
      trsent: {
        pools: ["Access Advance Hevc Members", "Via-La Hevc Members", "Avanci Video Members"]
      },
      trsentUS: {
        pools: ["Access Advance Hevc Members", "Via-La Hevc Members", "Avanci Video Members"]
      }
    },
    filters: {
      v5: {
        sort: "-alpha_score",
        count_by: "grant",
        pub_status: ["Active", "Unknown"],
        alpha_threshold: 60,
        pools: ["Via-La Hevc Patents", "Access Advance Hevc Patents"]
      },
      trsent: {
        sort: "-alpha_score",
        count_by: "grant",
        pub_status: ["Active", "Unknown"],
        alpha_threshold: 60,
        pools: ["Via-La Hevc Patents", "Access Advance Hevc Patents"]
      },
      trsentUS: {
        sort: "-alpha_score",
        count_by: "grant",
        pub_status: ["Active", "Unknown"],
        alpha_threshold: 60,
        pools: ["Via-La Hevc Patents", "Access Advance Hevc Patents"]
      }
    }
  },
  avc: {
    version: "v2",
    versionsPublic: ["v2"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/360007517393-Video-Codec-Zone-Methodology",
    fields: {
      v2: "avc_v2a_ft_c"
    },
    venn: {
      v2: {
        pools: ["Via-La Avc Members", "Avc Declarants"]
      }
    },
    filters: {
      v2: {
        sort: "-alpha_score",
        count_by: "grant",
        pub_status: ["Active", "Unknown"],
        alpha_threshold: 60,
        pools: ["Via-La Avc Patents"]
      }
    }
  },
  vvc: {
    version: "v2",
    versionsPublic: ["v2"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/12900363504535",
    fields: {
      v2: "vvc_v2a_ft_c"
    },
    venn: {
      v2: {
        pools: ["Access Advance Vvc Members", "Via-La Vvc Members"]
      }
    },
    filters: {
      v2: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 72,
        pools: ["Access Advance Vvc Patents", "Via-La Vvc Patents"]
      }
    }
  },
  lte: {
    version: "v3",
    versionsPublic: ["v2", "v3"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/4447452742167",
    fields: {
      v2: "lte_v2c_ft",
      v3: "lte_v3a_ft_c"
    },
    venn: {
      v2: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      },
      v3: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      }
    },
    filters: {
      v2: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pub_status: ["Active", "Unknown"],
        pools: ["4g Declared"]
      },
      v3: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pub_status: ["Active", "Unknown"],
        pools: ["4g Declared"]
      }
    }
  },
  "5g": {
    version: "v2",
    versionsPublic: ["v1"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/4447452742167",
    fields: {
      v1: "5g_v1c_ft",
      v2: "5g_v2a_ft_c"
    },
    venn: {
      v1: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      },
      v2: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      }
    },
    filters: {
      v1: {
        sort: "-alpha_score",
        count_by: "pub",
        pub_status: ["Active", "Unknown"],
        alpha_threshold: 50,
        pools: ["5g Declared"]
      },
      v2: {
        sort: "-alpha_score",
        count_by: "pub",
        pub_status: ["Active", "Unknown"],
        alpha_threshold: 50,
        pools: ["5g Declared"]
      }
    }
  },
  lte_ran: {
    version: "v0",
    versionsPublic: ["v0"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/4415793634711",
    fields: {
      v0: "lteran_v0d_ft_c",
      v0_internal: "lteran_v0d_ft_c_internal"
    },
    venn: {
      v0: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      },
      v0_internal: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      }
    },
    filters: {
      v0: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pools: ["4g Declared Families"]
      },
      v0_internal: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pools: ["4g Declared Families"]
      }
    }
  },
  "5g_ran": {
    version: "v0",
    versionsPublic: ["v0"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/4415793634711",
    fields: {
      v0: "5gran_v1f_ft_c",
      v0_internal: "5gran_v1f_ft_c_internal"
    },
    venn: {
      v0: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      },
      v0_internal: {
        pools: ["5G Declared Families", "4G Declared Families", "3G Declared Families"]
      }
    },
    filters: {
      v0: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pools: ["5g Declared Families"]
      },
      v0_internal: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pools: ["5g Declared Families"]
      }
    }
  },
  wifi6: {
    version: "v1",
    versionsPublic: ["v0", "v1"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/7250711661847",
    fields: {
      v0: "wifi6_v0a_ft_c",
      v1: "wifi6_v1a_ft_c"
    },
    venn: {
      v0: {
        pools: ["Ieee Wifi 6 Contributors", "Sisvel Wifi 6 Members"]
      },
      v1: {
        pools: ["Ieee Wifi 6 Contributors", "Sisvel Wifi 6 Members"]
      }
    },
    filters: {
      v0: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pools: ["Sisvel Wifi 6 Members"]
      },
      v1: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 64,
        pools: ["Sisvel Wifi 6 Members"]
      }
    }
  },
  genai: {
    version: "v1",
    versionsPublic: ["v0", "v1"],
    docsUrl: "https://support.unifiedpatents.com/hc/en-us/articles/33295116423319",
    fields: {
      v0: "genai_v0",
      v1: "genai_v1b_ft_c"
    },
    venn: {
      v0: {
        pools: ["Autoregressive Models", "Large Language Models", "Variational Autoencoder"]
      },
      v1: {
        pools: ["Autoregressive Models", "Large Language Models", "Variational Autoencoder"]
      }
    },
    filters: {
      v0: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 0,
        pools: []
      },
      v1: {
        sort: "-alpha_score",
        count_by: "pub",
        alpha_threshold: 50,
        pools: ["Large Language Models"]
      }
    }
  }
};
